import { useMemo } from 'react'

export const useRandomID = () => useMemo(() => Date.now() + Math.floor(Math.random() * 1000), [])

export const useGetRandomID = () => {
  return () => Date.now() + Math.floor(Math.random() * 1000)
}
